import { lazy } from 'solid-js'
import { messages } from '../../pages/inbox-page/inbox-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/inbox-page/inbox-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/inbox',
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
